export enum HomeCtaAction {
  SIGN_UP = "sign-up",
  DEMO = "demo",
}
